import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IFundraiser } from 'src/app/fundraiser/models/fundraiser.model';
import { IPaymentConfig } from 'src/app/common/payment/models/payment.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { PaymentUtilService } from 'src/app/common/payment/services';
import { ActivatedRoute } from '@angular/router';
import { PaymentV2Service, UtilService, VariablesService, VwoService } from 'src/app/shared/services';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-donate-btn',
  standalone: true,
  imports: [CommonModule, SharedModule, MatButtonModule],
  templateUrl: './donate-btn.component.html',
  styleUrls: ['./donate-btn.component.scss']
})
export class DonateBtnComponent implements OnInit, OnDestroy {

  @Input() amount;
  @Input() label;
  @Input() disabled;
  @Input() isOrderLoading;
  @Input() btnClass;
  @Input() btnType = 'submit';
  @Input() type;
  @Input() hideAmount;
  @Input() month_interval;
  @Input() isSipCause;
  @Input() ngo_Sip;
  @Input() fundraiser: IFundraiser;
  @Input() payment_config: IPaymentConfig;
  @Input() miniStory;
  @Output() onClickListner = new EventEmitter();
  // hideTicker;
  currency;
  subs: Subscription[] = [];
  params;
  isMobile;
  constructor(
    private paymentUtilService: PaymentUtilService,
    public actRoute: ActivatedRoute,
    public vwo: VwoService,
    public vars: VariablesService,
    public util: UtilService,
    public paymentV2: PaymentV2Service
  ) { }

  ngOnInit() {
    this.setConfig();
    this.isMobile = this.util?.isMobile();
    this.params = this.actRoute.snapshot.queryParams;
    this.actRoute.queryParams.subscribe((res) => {
      this.params = res;
    });
    this.subs.push(this.paymentUtilService.paymentCurrency.subscribe({ next: (res) => this.currency = res }));
    this.subs.push(this.actRoute.queryParams.subscribe((params) => {
      this.month_interval = params['month_interval'];
    }));
    if (this.params?.hide_el?.match('2|3')) {
      this.label = 'Contribute';
    }
  }

  setConfig() {
    this.subs.push(this.paymentUtilService.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
      }
    }));
  }

  getButtonState() {
    return this.isOrderLoading ? this.isOrderLoading : this.disabled;
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  // showTicker = (e) => {
  //   this.hideTicker = e;
  // }

}
